var _defs, _path, _path2, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNerkhArz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.29 52.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5bd18;\n      }\n\n      .cls-2 {\n        fill: #b4d569;\n      }\n\n      .cls-3 {\n        fill: #27b173;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.22,38.84L1.41,26.52,25.07,0l13.81,12.32L15.22,38.84ZM2.82,26.44l12.32,10.99L37.47,12.4,25.15,1.41,2.82,26.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.3,47.93L0,34.28,24.99,6.26l15.3,13.65L15.3,47.93Zm-11.07-13.89l10.83,9.66,21-23.54-10.83-9.66L4.24,34.04Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.39,
    y: 16.93,
    width: 17.51,
    height: 34.54,
    transform: "translate(27.88 -4.73) rotate(41.73)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNerkhArz);
export default __webpack_public_path__ + "static/media/nerkh-arz.b3500049956862a52b4defd69b5cd424.svg";
export { ForwardRef as ReactComponent };